import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-white">
        <Logo size={96} />
        <div className="h-6 w-6 rounded-full border-2 border-brand border-t-transparent adminia-spin" />
        <p className="text-sm text-muted-foreground">Chargement…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/connexion" replace />;
  return children;
}
